/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SendClaimEmailRequestAttachmentsInner } from './SendClaimEmailRequestAttachmentsInner';
import {
    SendClaimEmailRequestAttachmentsInnerFromJSON,
    SendClaimEmailRequestAttachmentsInnerFromJSONTyped,
    SendClaimEmailRequestAttachmentsInnerToJSON,
    SendClaimEmailRequestAttachmentsInnerToJSONTyped,
} from './SendClaimEmailRequestAttachmentsInner';
import type { EmailRecipientInput } from './EmailRecipientInput';
import {
    EmailRecipientInputFromJSON,
    EmailRecipientInputFromJSONTyped,
    EmailRecipientInputToJSON,
    EmailRecipientInputToJSONTyped,
} from './EmailRecipientInput';

/**
 * Payload to send an email from a claim via Gmail
 * @export
 * @interface SendClaimEmailRequest
 */
export interface SendClaimEmailRequest {
    /**
     * Primary recipients (required, at least one)
     * @type {Array<EmailRecipientInput>}
     * @memberof SendClaimEmailRequest
     */
    to: Array<EmailRecipientInput>;
    /**
     * CC recipients
     * @type {Array<EmailRecipientInput>}
     * @memberof SendClaimEmailRequest
     */
    cc?: Array<EmailRecipientInput>;
    /**
     * BCC recipients
     * @type {Array<EmailRecipientInput>}
     * @memberof SendClaimEmailRequest
     */
    bcc?: Array<EmailRecipientInput>;
    /**
     * Email subject line
     * @type {string}
     * @memberof SendClaimEmailRequest
     */
    subject: string;
    /**
     * Plain text email body
     * @type {string}
     * @memberof SendClaimEmailRequest
     */
    bodyText?: string;
    /**
     * HTML email body
     * @type {string}
     * @memberof SendClaimEmailRequest
     */
    bodyHtml?: string;
    /**
     * Attachments with a combined decoded size limit of 18 MB
     * @type {Array<SendClaimEmailRequestAttachmentsInner>}
     * @memberof SendClaimEmailRequest
     */
    attachments?: Array<SendClaimEmailRequestAttachmentsInner>;
    /**
     * Optional Gmail thread ID to reply to
     * @type {string}
     * @memberof SendClaimEmailRequest
     */
    inReplyToGmailThreadId?: string;
}

/**
 * Check if a given object implements the SendClaimEmailRequest interface.
 */
export function instanceOfSendClaimEmailRequest(value: object): value is SendClaimEmailRequest {
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function SendClaimEmailRequestFromJSON(json: any): SendClaimEmailRequest {
    return SendClaimEmailRequestFromJSONTyped(json, false);
}

export function SendClaimEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendClaimEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'to': ((json['to'] as Array<any>).map(EmailRecipientInputFromJSON)),
        'cc': json['cc'] == null ? undefined : ((json['cc'] as Array<any>).map(EmailRecipientInputFromJSON)),
        'bcc': json['bcc'] == null ? undefined : ((json['bcc'] as Array<any>).map(EmailRecipientInputFromJSON)),
        'subject': json['subject'],
        'bodyText': json['bodyText'] == null ? undefined : json['bodyText'],
        'bodyHtml': json['bodyHtml'] == null ? undefined : json['bodyHtml'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(SendClaimEmailRequestAttachmentsInnerFromJSON)),
        'inReplyToGmailThreadId': json['inReplyToGmailThreadId'] == null ? undefined : json['inReplyToGmailThreadId'],
    };
}

export function SendClaimEmailRequestToJSON(json: any): SendClaimEmailRequest {
    return SendClaimEmailRequestToJSONTyped(json, false);
}

export function SendClaimEmailRequestToJSONTyped(value?: SendClaimEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'to': ((value['to'] as Array<any>).map(EmailRecipientInputToJSON)),
        'cc': value['cc'] == null ? undefined : ((value['cc'] as Array<any>).map(EmailRecipientInputToJSON)),
        'bcc': value['bcc'] == null ? undefined : ((value['bcc'] as Array<any>).map(EmailRecipientInputToJSON)),
        'subject': value['subject'],
        'bodyText': value['bodyText'],
        'bodyHtml': value['bodyHtml'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(SendClaimEmailRequestAttachmentsInnerToJSON)),
        'inReplyToGmailThreadId': value['inReplyToGmailThreadId'],
    };
}

